module.exports = __webpack_public_path__ + "img/752.54a92789.png";